angular.module('dental')
	.directive('translatePart', ['$translatePartialLoader', ($translatePartialLoader) => {
		return {
			restrict: 'A',
			link($scope, $element, $attrs) {
				$translatePartialLoader.addPart($attrs.translatePart);
			}
		};
	}]);